var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tw-p-5 leading-tight" },
    [
      _c(
        "swiper",
        {
          attrs: { allowTouchMove: false },
          on: {
            init: _vm.onInit,
            swiper: _vm.onSwiper,
            slideChangeTransitionEnd: _vm.onSlideChangeTransitionEnd,
          },
        },
        [
          _c("swiper-slide", [
            _c(
              "div",
              {
                staticClass:
                  "illustration d-flex justify-content-around align-items-center tw-mb-4",
              },
              [
                _vm.Utils.isThemeBeepiz()
                  ? _c("i", {
                      staticClass: "phone",
                      domProps: { innerHTML: _vm._s(_vm.PhoneBeepizLogo) },
                    })
                  : _vm.Utils.isThemeSfr()
                  ? _c("i", {
                      staticClass: "phone",
                      domProps: { innerHTML: _vm._s(_vm.PhoneSFRLogo) },
                    })
                  : _c("i", {
                      staticClass: "phone",
                      domProps: { innerHTML: _vm._s(_vm.PhoneNeutralLogo) },
                    }),
                _vm._v(" "),
                _c("div", [
                  _c("i", { staticClass: "fa fa-chevron-right" }),
                  _vm._v(" "),
                  _c("i", { staticClass: "fa fa-chevron-right" }),
                  _vm._v(" "),
                  _c("i", { staticClass: "fa fa-chevron-right" }),
                ]),
                _vm._v(" "),
                _vm.Utils.isThemeBeepiz()
                  ? _c("i", {
                      staticClass: "desktopLogo",
                      domProps: { innerHTML: _vm._s(_vm.DesktopBeepizLogo) },
                    })
                  : _vm.Utils.isThemeSfr()
                  ? _c("i", {
                      staticClass: "desktopLogo",
                      domProps: { innerHTML: _vm._s(_vm.DesktopSFRLogo) },
                    })
                  : _c("i", {
                      staticClass: "desktopLogo",
                      domProps: { innerHTML: _vm._s(_vm.DesktopNeutralLogo) },
                    }),
              ]
            ),
            _vm._v(" "),
            _c("p", {
              staticClass: "explaination-1",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$tc(
                    "device.registrations.assocExplaination1",
                    _vm.getAvailableLicences,
                    {
                      count: _vm.getAvailableLicences,
                      theme: _vm.Utils.getApplicationName(),
                    }
                  )
                ),
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex py-2" },
              [
                _c(
                  "Btn",
                  {
                    staticClass: "secondary ml-auto",
                    class: { disabled: !_vm.datiId },
                    nativeOn: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.next($event)
                      },
                    },
                  },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.$t("global.next")))]),
                    _vm._v(" "),
                    _c("i", { staticClass: "fa fa-chevron-right" }),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("swiper-slide", [
            _c(
              "div",
              {
                staticClass: "messages",
                staticStyle: { "margin-top": "0", position: "static" },
              },
              [
                !!_vm.backendErrorMessages.length
                  ? _c("div", { staticClass: "message error show" }, [
                      _c("i", {
                        staticClass: "fa fa-times",
                        on: {
                          click: function ($event) {
                            return _vm.removeErrorsMessages()
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "fa fa-exclamation-circle indicator",
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "message-inner" },
                        _vm._l(_vm.backendErrorMessages, function (message) {
                          return _c("div", {
                            domProps: { textContent: _vm._s(message) },
                          })
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-row row standard" }, [
              _c("label", { staticClass: "col-12" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("device.registrations.datiName")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.datiName,
                    expression: "datiName",
                  },
                ],
                ref: "phone",
                staticClass: "form-input col-12",
                attrs: { type: "text" },
                domProps: { value: _vm.datiName },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.datiName = $event.target.value
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-row row standard" },
              [
                _c("label", { staticClass: "col-12" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("device.registrations.phonenumber")) +
                      " (" +
                      _vm._s(_vm.$t("global.optional")) +
                      ")\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("FormInputPhone", {
                  attrs: {
                    name: "phoneNumber",
                    isInvalid:
                      _vm.phoneNumberShowError && _vm.phoneNumberIsInvalid,
                  },
                  on: {
                    input: _vm.onPhoneInput,
                    blur: function ($event) {
                      return _vm.blurPhoneInput()
                    },
                  },
                  model: {
                    value: _vm.phoneNumber,
                    callback: function ($$v) {
                      _vm.phoneNumber = $$v
                    },
                    expression: "phoneNumber",
                  },
                }),
                _vm._v(" "),
                _vm.phoneNumberShowError && _vm.phoneNumberIsInvalid
                  ? _c("FormError", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "device.registrations.errors.invalidPhoneFormat"
                            )
                          ) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-row row standard" }, [
              _c("label", { staticClass: "col-12" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("device.registrations.profile")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.datiProfile,
                      expression: "datiProfile",
                    },
                  ],
                  staticClass: "form-input col-12",
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.datiProfile = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c("option", { domProps: { value: null } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("device.registrations.profileSelectPlaceholder")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.props.profiles, function (profile) {
                    return _c(
                      "option",
                      { domProps: { value: profile.profileId } },
                      [_vm._v(_vm._s(profile.meta.name))]
                    )
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-row row standard" }, [
              _c("label", { staticClass: "col-12" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("device.groupSelect")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.datiGroup,
                      expression: "datiGroup",
                    },
                  ],
                  staticClass: "form-input col-12",
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.datiGroup = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c("option", { attrs: { value: "null" } }, [
                    _vm._v(_vm._s(_vm.$t("device.noGroup"))),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.props.groups, function (group) {
                    return _c("option", { domProps: { value: group.id } }, [
                      _vm._v(_vm._s(group.name)),
                    ])
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _vm.hasAnalytic
              ? _c("div", { staticClass: "form-row row standard" }, [
                  _c("label", { staticClass: "col-12" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("device.registrations.analyticCode")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.analyticCode,
                        expression: "analyticCode",
                      },
                    ],
                    ref: "analytic",
                    staticClass: "form-input col-12",
                    attrs: { type: "text", maxlength: "30" },
                    domProps: { value: _vm.analyticCode },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.analyticCode = $event.target.value
                      },
                    },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex py-2" },
              [
                _c(
                  "Btn",
                  {
                    staticClass: "secondary prev-button ",
                    nativeOn: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.prev($event)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-chevron-left" }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("global.prev")))]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "Btn",
                  {
                    staticClass: "secondary ml-auto",
                    class:
                      !_vm.phoneNumberIsInvalid ||
                      _vm.phoneNumberNationnal === undefined
                        ? ""
                        : "disabled",
                    nativeOn: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.next($event)
                      },
                    },
                  },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.$t("global.next")))]),
                    _vm._v(" "),
                    _c("i", { staticClass: "fa fa-chevron-right" }),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("swiper-slide", [
            _c("p", { staticClass: "explaination-2 mt-0 mb-2" }),
            _vm._v(" "),
            _c("div", { staticClass: "qrcode-container" }, [
              _c(
                "div",
                { class: "qrcode-inner" },
                [
                  _c("LoadingMini", { ref: "loading" }),
                  _vm._v(" "),
                  _c("QRCode", {
                    class: { show: _vm.code != "" },
                    attrs: {
                      text: _vm.code,
                      size: 150,
                      color: "#212121",
                      "bg-color": "#FFFFFF",
                      "error-level": "Q",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("p", { staticClass: "mt-0 mb-1" }, [
                _c("a", { attrs: { href: _vm.code, target: "_blank" } }, [
                  _vm._v(_vm._s(_vm.code)),
                ]),
              ]),
              _vm._v(" "),
              _vm.code != ""
                ? _c(
                    "span",
                    { staticClass: "text-info-600" },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("device.registrations.expiresIn"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("Countdown", {
                        attrs: { date: _vm.liveUntil },
                        on: { expired: _vm.handleExpired },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("p", {
              staticClass: "explaination-3 my-2",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("device.registrations.assocExplaination3")
                ),
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "center" },
              [
                _c(
                  "Btn",
                  { staticClass: "primary reverse" },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: _vm.getDatiLink, tag: "div" } },
                      [
                        _c("i", { staticClass: "fa fa-mobile-phone" }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("device.btns.goToShow"))),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }